angular.module('picmonicng').directive('autofocus', function () {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      setTimeout(function () {
        element[0].focus();
      }, 10);
    },
  };
});
